export const generateTitleFromSlug = (slug: string): string => {
  try {
    let actualSlug = slug;
    const slugMatch = slug.match(/\/collection\/([^\/]+)/);
    if (slugMatch) {
      actualSlug = slugMatch[1];
    } else if (slug.startsWith('/')) {
      actualSlug = slug.split('/').filter(part => part).pop() || slug;
    }

    actualSlug = decodeURIComponent(actualSlug);

    let title = actualSlug
      .replace(/\+cars\/?$/, '')
      .replace(/\+/g, ' ')
      .split(' ')
      .map(word => 
        word.split('-').map(part =>
          part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
        ).join(' ')
      )
      .join(' ')
      .trim();

    return title;
  } catch (error) {
    console.error('Error generating title from slug:', error);
    let actualSlug = slug;
    const slugMatch = slug.match(/\/collection\/([^\/]+)/);
    if (slugMatch) {
      actualSlug = slugMatch[1];
    } else if (slug.startsWith('/')) {
      actualSlug = slug.split('/').filter(part => part).pop() || slug;
    }
    
    const cleanSlug = actualSlug.replace(/\+cars\/?$/, '').replace(/[+]/g, ' ');
    return cleanSlug.split(' ').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
  }
};

export const generateSEOTitleFromSlug = (slug: string): string => {
  const baseTitle = generateTitleFromSlug(slug);
  return `${baseTitle}`;
};

export const getDisplayNameFromFilterValue = (value: string, filterData: any): string | null => {
  if (!filterData || !value) return null;

  if (filterData.brand_model) {
    for (const brandModel of filterData.brand_model) {
      const brandSlug = brandModel.brand_name?.toLowerCase();
      if (brandSlug === value.toLowerCase()) {
        return brandModel.brand_name;
      }
      
      if (brandModel.brand_name.toLowerCase() === value.toLowerCase()) {
        return brandModel.brand_name;
      }
      
      if (brandModel.models) {
        for (const model of brandModel.models) {
          const modelSlug = model.model_name?.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '');
          if (modelSlug === value.toLowerCase()) {
            return model.model_name;
          }
        }
      }
    }
  }

  const filterTypes = ['body_type', 'fuel_type', 'transmission', 'seat_capacity', 'budget_range'];
  
  for (const filterType of filterTypes) {
    if (filterData[filterType]) {
      for (const item of filterData[filterType]) {
        if (item.value.toLowerCase() === value.toLowerCase()) {
          return item.key || item.value;
        }
      }
    }
  }

  return null;
}; 